import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  data:[],
  preprocessData :[],
  preprocessKeyData :{
    checked: 0
  },
  predictionData:[],
  PreData:[],
    currentStep:0,
  fileName: '',
  trainModel: {},
  testPredictionData: {},
  summaryData:[],
  btnLoader:false,
  btnSummary:false,
  predictTime:[],
  steps: ['Load Data'],
  currentTemplate: {}
};


const resourceEditorSlice = createSlice({
  name: 'resourceEditor',
  initialState,
  reducers: {
    setResourceEditorModelData: (state, action) => {
      return {
        ...state,
        ...action.payload,
        showResEditorInitialState: true,
      };
    },
    /*eslint array-callback-return: */
    updateResourceEditorState(state, action) {
      const keys = Object.keys(action.payload);
      keys.map(key => {
        if (key === 'ResourceEditor') {
          state.showResEditorInitialState = false;
          state[key] = action.payload[key];
        } else {
          state[key] = action.payload[key];
        }
      });
    },
    setResourceIsLoading(state, action) {
      state.isloading = action?.payload?.isloading;
    },
    setCurrentStep(state, action){
      state.currentStep = action?.payload
    },
    setFileName(state, action){
      state.fileName = action?.payload
    },
    uploadDataMiniapp(state,action){
      state.data = action?.payload;
      state.PreData = action?.payload;
    },
    updatepreprocessData(state,action){
       state.preprocessData = action?.payload;
    },
    updatepreprocessKeyData(state,action){
      state.preprocessKeyData = action?.payload;
   },
   updateTrainModel(state,action){
      state.trainModel = action?.payload;
   },
   updateTestPrediction(state,action){
      state.testPredictionData = action?.payload;
   },
    updatePredictionData(state,action){
      state.predictionData = action?.payload;
    },
    setSummaryData(state,action){
      state.summaryData = action?.payload;
    },
    setBtnLoader(state,action){
      state.btnLoader = action?.payload;
    },
    setBtnSummary(state,action){
      state.btnSummary = action?.payload;
    },
    setPredictTime(state,action){
      state.predictTime = action?.payload
    },
    setSteps(state,action){
      return{...state,steps:action.payload}
    },
    resetResourceEditor:()=>initialState,
  },
});

const { reducer, actions } = resourceEditorSlice;

export const { setResourceEditorModelData, updateResourceEditorState ,uploadDataMiniapp,
  updatepreprocessData, updatePredictionData,setCurrentStep,setFileName,updatepreprocessKeyData,updateTrainModel,updateTestPrediction,
  setSummaryData,setBtnLoader,setBtnSummary,resetResourceEditor,setPredictTime,setSteps
} = actions;
export default reducer;
